module.exports = __webpack_public_path__ + "img/cme.43ee0a98.svg";